
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.844 34.974l15.564-15.52 5.486 5.47L3.392 35.182a2.31 2.31 0 01-2.264-.016l-.284-.192zm13.994-17.085L0 32.684V3.094l14.838 14.795zm9.273-6.114l7.249 4.018a2.226 2.226 0 011.154 1.942c0 .804-.442 1.546-1.154 1.942l-7.447 4.128-5.934-5.916 6.132-6.114zM.68.64A2.31 2.31 0 013.392.288l18.7 10.368-5.684 5.668L.68.64z","fill":"#fff"}})])
          )
        }
      }
    